import { PageableResponse } from "../PageableResponse";
import { FileClient, RestClient } from "../RestClient";

export type B040020FindRequest = Partial<{
  kanryoKbn: string;
  hachuYmdFrom: string;
  hachuYmdTo: string;
  nyukayoteiYmdFrom: string;
  nyukayoteiYmdTo: string;
  eigyoCdFrom: string;
  eigyoCdTo: string;
  bumonCdFrom: string;
  bumonCdTo: string;
  shainCdFrom: string;
  shainCdTo: string;
  hachudenpyoNoFrom: string;
  hachudenpyoNoTo: string;
  shireCd: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B040020FindResponse = {
  hachuYmd: string;
  nyukayoteiYmd: string;
  hachudenpyoNo: string;
  hachudenpyoNoF: string;
  shireNm: string;
  shainNm: string;
  bumonNm: string;
  hachuKin: string;
  hachuzanKin: string;
  nyukakakuteiKin: string;
  kanryoKbnView: string;
};

// 検索メソッド
export const B040020Find = (props: B040020FindRequest) => {
  return RestClient.get<PageableResponse<B040020FindResponse[]>>(
    "b040020/find",
    {
      params: props,
    }
  );
};

export type B040020GetRequest = Partial<{
  hachudenpyoNo: string;
}>;

export type B040020GetResponse = {
  hachudenpyoNo: string;
  hachudenpyoNoF: string;
  hachuYmd: string;
  headerNyukayoteiYmd: string;
  shireCd: string;
  shireShokuchiKbn: string;
  shireNm: string;
  otodokeCd: string;
  otodokeShokuchiKbn: string;
  otodokeNm: string;
  shainCd: string;
  shainNm: string;
  bumonCd: string;
  bumonNm: string;
  eigyoCd: string;
  defaultSokoCd: string;
  defaultSokoNm: string;
  defaultSokoshubetsuKbn: string;
  bikoCd: string;
  biko: string;
  version: string;
  hachugyoNo: number;
  uchiwakeKbn: string;
  nyukayoteiYmd: string;
  shohinCd: string;
  shohinShokuchiKbn: number;
  shohinNm: string;
  hachusu: string;
  shiresu: string;
  tenyuryokuKbn: string;
  basetanka: string;
  hachutanka: string;
  hachuKin: string;
  sokoCd: string;
  sokoNm: string;
  sokoshubetsuKbn: string;
  meisaibikoCd: string;
  meisaibiko: string;
  kanryoKbn: string;
};

// 発注データ取得メソッド
export const B040020Get = (props: B040020GetRequest) => {
  return RestClient.get<B040020GetResponse[]>("b040020/get", {
    params: props,
  });
};

export type B040020GetCopyRequest = Partial<{
  hachudenpyoNo: string;
}>;

// 発注データ取得複製メソッド
export const B040020GetCopy = (props: B040020GetCopyRequest) => {
  return RestClient.get<B040020GetResponse[]>("b040020/get/copy", {
    params: props,
  });
};

// 発注データExcel出力メソッド
export const B040020GetExcel = (props: B040020FindRequest) => {
  return FileClient.get("b040020/get/excel", { params: props });
};
